const columns = [
    {
        text: 'Data',
        className: 'text-max-sm pl-2'
    },
    {
        text: 'Hora',
        className: 'text-max-sm pl-2'
    },
    {
        text: 'Evento',
        className: 'text-max-sm pl-2',
        width: '100%'
    }
];

export default columns;
